<template>
  <div class="home-subscribe">
    <el-select
      v-model="value"
      size="large"
      clearable
      placeholder="订阅区块链"
      @change="handleSelect"
    >
      <el-option
        v-for="(item, i) in options"
        :key="item.ChainId + i"
        :label="item.ChainName"
        :value="item.ChainId"
      >
      </el-option>
    </el-select>

    <el-button class="subscribe-btn" type="primary" @click="handleAll()">全部订阅</el-button>
  </div>
</template>

<script>
export default {
  name: 'SubscribeBlock',
  data() {
    return {
      value: '',
      options: []
    }
  },
  mounted() {
    this.getOptions()
  },
  methods: {
    getOptions() {
      let param = {
        offset: 0,
        limit: 50
      }
      this.$apis.home.getSubscribeQueryList(param).then(res => {
        if (res.data && res.data.items) {
          //DPOS共识类型的链，不可在首页概览选择
          let items = res.data.items.filter(e => {
            return e.Consensus != 'DPOS'
          })

          this.options = items
          let storeId = sessionStorage.getItem('cbaas_chain_id')
          let storeItem = this.options.filter(ele => ele.ChainId === storeId)
          let id = storeItem.length > 0 ? storeId : this.options[0]?.ChainId
          this.value = id
          this.$store.commit('updateChainCid', id)
          sessionStorage.setItem('cbaas_chain_id', id)
        }
        if (res.data && res.data.items.length === 0) {
          this.$store.commit('updateLoading', false)
          this.$message.warning('请订阅区块链！')
        }
      })
    },
    handleSelect(id) {
      id && this.$store.commit('updateChainCid', id)
      sessionStorage.setItem('cbaas_chain_id', id)
    },
    handleAll() {
      this.$router.push('/subscribeBlock')
    }
  }
}
</script>

<style scoped lang="scss">
@import '@/styles/variables/theme';
@import '@/styles/variables/adaptation';

@include theme(
  'home-subscribe',
  (
    //home subscribe
      --home-subscribe-bg: #051434,
    --home-subscribe-color: #fff,
    --home-subscribe-border-color: rgba(69, 194, 255, 0.5),
    --home-subscribe-input-color: #fff,
    --home-subscribe-input-placeholder-color: #fff,
    --home-subscribe-input-suffix-color: #45c2ff
  ),
  (
    //home subscribe
      --home-subscribe-bg: #fff,
    --home-subscribe-color: #2a8dcb,
    --home-subscribe-border-color: #ebebeb,
    --home-subscribe-input-color: #122836,
    --home-subscribe-input-placeholder-color: #122836,
    --home-subscribe-input-suffix-color: #122836
  )
);
.home-subscribe {
  @include adaptation(
    (
      //工具栏订阅组件
        --home-subscribe-width: 230px,
      --home-subscribe-border-radius: 4px,
      --home-subscribe-border-width: 1px,
      --home-subscribe-input-height: 32px,
      --home-subscribe-input-suffix-width: 32px,
      --home-subscribe-input-suffix-fontsize: 16px
    )
  );
  display: flex;
  align-items: center;
  background: var(--home-subscribe-bg);
  border-radius: var(--home-subscribe-border-radius);
  border: var(--home-subscribe-border-width) solid var(--home-subscribe-border-color);
  width: var(--home-subscribe-width);

  /deep/ {
    .el-input {
      .el-input__inner {
        height: var(--home-subscribe-input-height);
        line-height: var(--home-subscribe-input-height);
        border: none;
        background: transparent;
        color: var(--home-subscribe-input-color);

        &::placeholder {
          color: var(--home-subscribe-input-placeholder-color);
        }
      }

      .el-input__suffix {
        right: 0;

        .el-input__suffix-inner {
          .el-input__icon {
            width: var(--home-subscribe-input-suffix-width);
            color: var(--home-subscribe-input-suffix-color);
            line-height: var(--home-subscribe-input-height);
            font-size: var(--home-subscribe-input-suffix-fontsize);
          }
        }
      }
    }

    .subscribe-btn {
      margin-top: calc(0px - var(--home-subscribe-border-width));
      margin-right: calc(0px - var(--home-subscribe-border-width));
    }
  }
}
</style>
